export interface FittingSession {
  id: string;
  timestamp: number;
  handicap: number;
  clubKey: string;
  baselineFormatted: Record<string, string>;
  bestSpecLabel: string;
  bestSpecFormatted: Record<string, string>;
  bestGearLabel: string;
  bestGearFormatted: Record<string, string>;
  distanceGain: number;
}

export class SessionStore {
  private static KEY = 'eldrick_sessions';

  static save(session: FittingSession): void {
    const sessions = SessionStore.getAll();
    sessions.push(session);
    try {
      localStorage.setItem(SessionStore.KEY, JSON.stringify(sessions));
    } catch {
      // localStorage full or unavailable — silently fail
    }
  }

  static getAll(): FittingSession[] {
    try {
      const raw = localStorage.getItem(SessionStore.KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  static getLast(): FittingSession | null {
    const sessions = SessionStore.getAll();
    return sessions.length > 0 ? sessions[sessions.length - 1] : null;
  }

  static clear(): void {
    try {
      localStorage.removeItem(SessionStore.KEY);
    } catch {
      // silently fail
    }
  }
}
